import { useQuery } from "@tanstack/react-query";
import { backendService } from "../services/backend.service";
import type { Request } from "../utils/models";

export const useOpenShifts = (departmentId?: string) => {
	return useQuery<Request[]>({
		queryKey: ["openShifts", departmentId],
		queryFn: async () => {
			const response = await backendService.getOpenShifts(departmentId);
			return response.data;
		},
		enabled: !!departmentId,
	});
};
